import _ from "lodash";
import { CURRICULUM_TYPE_ORDER_MAPPING } from "Constants";
import { getIsLearningCoursesEnabled } from "Teacher/routes/LearningCourses/modules/Utils";

const getCurriculumOptions = ({ curriculumPrograms, t }) => {
  const isLearningCoursesEnabled = getIsLearningCoursesEnabled();

  let defaultOption;
  const sortedCurriculumList = _.orderBy(
    curriculumPrograms,
    [obj => CURRICULUM_TYPE_ORDER_MAPPING[obj.type]],
    "asc"
  );

  const options = [
    {
      key: "root",
      children: _.map(sortedCurriculumList, "id"),
    },
  ];

  _.forEach(sortedCurriculumList, (curriculum, index) => {
    const title = isLearningCoursesEnabled
      ? t("common:courses_with_label", {
          label: curriculum.acronym,
        })
      : t("common:classes_with_label", {
          label: curriculum.acronym,
        });

    const curriculumOption = {
      key: curriculum.id,
      title,
      tier: 1,
      parent: "root",
      children: [],
    };

    options.push(curriculumOption);

    if (index == 0) {
      defaultOption = curriculumOption;
    }
  });

  return { curriculumOptions: options, defaultOption };
};

export const getCurriculumOptionsMemoized = _.memoize(
  params => getCurriculumOptions(params),
  params => JSON.stringify(params)
);
